var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 202,
    viewBox: "0 0 529 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_524_36928",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 529,
    height: 202
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 528.486,
    height: 201.583,
    rx: 15,
    fill: "#ED713C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_524_36928)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 63.1457,
    cy: 233.353,
    rx: 136.611,
    ry: 123.798,
    fill: "#F7521B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 483.983,
    cy: -31.772,
    rx: 153.827,
    ry: 123.798,
    fill: "url(#paint0_linear_524_36928)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_36928",
    x1: 403.168,
    y1: 92.0262,
    x2: 516.101,
    y2: -80.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173363,
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981183,
    stopColor: "#FF924F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCardIcon);
export default __webpack_public_path__ + "static/media/background-card-icon.60d3f067305760c5219ed874d0f25329.svg";
export { ForwardRef as ReactComponent };